import { attr, fk } from 'redux-orm'
import Base from './Base'

class BillingInvoiceItem extends Base {
  static get fields () {
    return {
      id: attr(),
      position: attr(),
      description: attr(),
      unit: attr(),
      quantity: attr(),
      price: attr(),
      vatPercentage: attr(),
      invoiceId: fk('billingInvoice', 'items')
    }
  }
}

BillingInvoiceItem.modelName = 'billingInvoiceItem'

export default BillingInvoiceItem
